/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./ActionModal.vue?vue&type=template&id=6b74b553&scoped=true"
import script from "./ActionModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ActionModal.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ActionModal.vue?vue&type=style&index=0&id=6b74b553&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b74b553",
  null
  
)

export default component.exports